<template>
  <b-card no-body class="mt-3 border-0 shadowed h-100">
    <div class="d-flex px-3 my-2 align-items-center">
      <div class="flex-shrink-1 pr-2">
        <b-avatar
          variant="success"
          :text="displayName ? displayName.charAt(0) : ''"
          class="b-avatar"
        />
      </div>
      <div class="flex-grow-1 d-flex align-items-center">
        <div class="text-bold pr-2">
          <div v-if="posterId">
            <router-link :to="publicProfileRoute" class="profile-link">
              {{ displayName }}
            </router-link>
          </div>
          <div v-else>
            {{ displayName }}
          </div>
        </div>
      </div>
      <div class="flex-shrink-1 pr-3">
        <div class="caption">{{ date }} <span class="pl-1">|</span></div>
      </div>
      <div class="flex-shrink-1">
        <Like
          :number-of-likes="likes"
          :post-id="postId"
          :like-post="likePost"
          :did-like="reaction !== null"
          v-bind:icon-only="true"
          v-bind:icon-big="true"
          v-if="!disableSubmition"
        />
      </div>
      <div class="flex-shrink-1" v-if="isUserPost">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret right>
          <template v-slot:button-content>
            <b-icon icon="three-dots-vertical"></b-icon>
          </template>
          <b-dropdown-item v-on:click="editPost(postId)">Edit</b-dropdown-item>
          <b-dropdown-item v-on:click="deletePost(postId)">Delete</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <div class="row mx-0">
      <div
        class="col-12 d-flex justify-content-center align-items-center post-title py-3"
        :class="color === null ? 'default-bg' : ''"
        v-bind:style="color"
      >
        <h6 class="text-white">{{ description }}</h6>
      </div>
    </div>
    <div class="row mx-4 pt-4">
      <div class="col-12 px-0 mb-3" :class="title ? '' : 'd-none'">
        {{ title }}
      </div>
    </div>
    <slot name="translations" />
    <div class="row px-4">
      <div class="col-12">
        <hr class="w-100 mt-2" />
      </div>
      <div class="col-12 d-flex justify-content-end pb-3">
        <Like
          :number-of-likes="likes"
          :post-id="postId"
          :like-post="likePost"
          :did-like="reaction !== null"
          v-if="!disableSubmition"
        />
        <span v-if="hasComments" v-b-toggle="'collapse-' + postId" class="caption comments">
          <span class="pl-2 pr-1">|</span>
          comments ({{ commentsLength }})
        </span>
      </div>
    </div>
    <slot />
  </b-card>
</template>

<script>
import Like from "../../atoms/Like";
import { USER_PUBLIC_PROFILE } from "../../paths.js";

export default {
  name: "PostCard",
  components: { Like },
  props: {
    displayName: String,
    date: String,
    title: String,
    description: String,
    postId: Number,
    reaction: null | String,
    likes: Number,
    color: String,
    isUserPost: Boolean,
    deletePost: Function,
    editPost: Function,
    likePost: Function,
    hasComments: Boolean,
    commentsLength: Number,
    disableSubmition: Boolean,
    posterId: Number,
  },
  computed: {
    publicProfileRoute: function () {
      return USER_PUBLIC_PROFILE(this.posterId);
    },
  },
};
</script>

<style scoped lang="scss">
.b-avatar {
  font-size: 1rem;
  width: 2.7rem !important;
  height: 2.7rem !important;
  color: $color-white;
  font-weight: bold;
}
.post-title {
  min-height: 120px;
  text-align: center;
}

.default-bg {
  background: rgba(0, 0, 0, 0) linear-gradient(rgb(239, 149, 70) 0%, rgb(226, 62, 59) 100%) repeat
    scroll 0% 0%;
}

::v-deep .dropdown-toggle-no-caret {
  padding-right: 0;
  padding-left: 0;
}

.comments {
  cursor: pointer;
}

.profile-link {
  color: $color-dark;
}
</style>
